import { logMosHubErrorAndFeature } from '../utils';
var AppHostTelemetryService = /** @class */ (function () {
    function AppHostTelemetryService(appHostSessionId, frameContext) {
        this._appHostSessionId = appHostSessionId;
        this._frameContext = frameContext;
    }
    AppHostTelemetryService.prototype.createScenario = function (name, appId, clientTimestamp) {
        return new TelemetryScenario(name, appId, this._appHostSessionId, this._frameContext, clientTimestamp);
    };
    return AppHostTelemetryService;
}());
export { AppHostTelemetryService };
var TelemetryScenario = /** @class */ (function () {
    function TelemetryScenario(scenarioName, appId, appHostSessionId, frameContext, clientTimestamp) {
        var _this = this;
        this.scenarioName = scenarioName;
        this.appId = appId;
        this.appHostSessionId = appHostSessionId;
        this.frameContext = frameContext;
        this.clientTimestamp = clientTimestamp;
        this.markPhase = function (phaseName) {
            //TODO pokankan - 5339579
            _this.logTelemetryEvent(phaseName.toString());
        };
        this.stop = function () {
            return _this.logTelemetryEvent("stop ".concat(_this.scenarioName));
        };
        this.fail = function (error) {
            return _this.logTelemetryEvent("fail ".concat(_this.scenarioName), error);
        };
        this.logTelemetryEvent = function (name, error) {
            var messagedReceivedTimeStamp = new Date().getTime();
            var info = {
                appHostSessionId: _this.appHostSessionId,
                appId: _this.appId,
                clientTimestamp: _this.clientTimestamp,
                error: error,
                frameContext: _this.frameContext,
                messageDelayMs: _this.clientTimestamp
                    ? messagedReceivedTimeStamp - _this.clientTimestamp
                    : 0,
                scenarioName: name,
            };
            logMosHubErrorAndFeature(info);
        };
        this.logTelemetryEvent(scenarioName);
    }
    return TelemetryScenario;
}());
//# sourceMappingURL=AppHostTelemetryService.js.map